import { FormattedMessage } from "react-intl";
import Cta from "../_control/Cta";
import { css } from "@emotion/react";
import { colors } from "shared-ui";



export default function EventFormSubmit({ onSubmit, loading, disabled, errorMsg, children, ...props }) {

    const isDisabled = loading || disabled

    return <div css={css`
        margin-top: 0.5em;
        display: flex;
        flex-direction: row-reverse;
        width: 100%;
        align-items: center;
        justify-content: space-between;
    `}
        {...props}
    >

        <div css={css`display: flex; gap: 1em;`}>

            {children}

            <Cta
                loading={loading}
                onClick={onSubmit}
                disabled={isDisabled}
            >
                <FormattedMessage id='save' />
            </Cta>

        </div>

        {errorMsg &&
            <div css={css`
                color: ${colors.warn};
            `}>
                {errorMsg}
            </div>
        }
    </div>
}